import { render, staticRenderFns } from "./CuponInfoDetails.vue?vue&type=template&id=f1679626&scoped=true&"
import script from "./CuponInfoDetails.vue?vue&type=script&lang=js&"
export * from "./CuponInfoDetails.vue?vue&type=script&lang=js&"
import style0 from "./CuponInfoDetails.vue?vue&type=style&index=0&id=f1679626&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1679626",
  null
  
)

export default component.exports